import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { PlusOutlined, MinusOutlined } from '@ant-design/icons'

import { LntDatePicker, LntFormGroup, LntFormItem, LntIconButton } from '@app/components/base'
import { Show } from '@app/components/util'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE, dateFormat } from '@app/constants'

import { isShowAppendButton, isShowRemoveButton } from './lib'

import styles from './styles.module.scss'

import type { LntIconButtonProps } from '@app/components/base/Button/Icon/types'

const FIELDS_NAME = 'notificationsTimes'

const lntIconButtonDefaultProps: LntIconButtonProps = {
  shape: 'circle',
  type: BUTTON_TYPE.text,
  size: SIZE.small
}

export const NotificationsTimes: React.FC = () => {
  const {
    control,
    formState: { isValid }
  } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: FIELDS_NAME,
    rules: { minLength: 1 }
  })

  return (
    <LntFormGroup
      required
      label='Время отправки уведомлений'
    >
      <ul className={ styles.notificationsTimes }>
        { fields.map((field, index) => (
          <li
            key={ field.id }
            className={ styles.notificationsTimes__item }
          >
            <LntFormItem
              name={ `${FIELDS_NAME}.${index}` }
              defaultValue={ field }
              validationOptions={ { rules: { required: true } } }
            >
              <LntDatePicker
                picker='time'
                placeholder={ FILTERS_PLACEHOLDERS.zeroTime }
                format={ dateFormat.HH_mm }
              />
            </LntFormItem>

            <Show condition={ isShowRemoveButton(fields, index) }>
              <LntIconButton
                { ...lntIconButtonDefaultProps }
                icon={ <MinusOutlined /> }
                onClick={ () => remove(index) }
              />
            </Show>

            <Show condition={ isShowAppendButton(fields, index) }>
              <LntIconButton
                { ...lntIconButtonDefaultProps }
                disabled={ !isValid }
                icon={ <PlusOutlined /> }
                onClick={ () => append(null) }
              />
            </Show>
          </li>
        )) }
      </ul>
    </LntFormGroup>
  )
}
